import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../shared/selectors/analytics';
import { getAnalyticsProduct } from '../../../../../shared/utils';
import { trackPublishWithVisibleViolationsConfirmClose } from './PremoderationConfirmModal.tracking';

export default function (
  $scope,
  $uibModalInstance,
  addFormService,
  publishTermsService,
  store,
  placingTermsApi,
  $rootScope,
) {
  'ngInject';

  const state = store.getState();

  const analyticsOfferStatus = selectAnalyticsOfferStatus(state);

  const getProduct = () => {
    const state = store.getState();

    if (publishTermsService.isNewPublishTermsEnabled()) {
      return selectAnalyticsProduct(state);
    } else {
      return getAnalyticsProduct(state, placingTermsApi);
    }
  };

  $scope.fixViolations = () => {
    const { form } = addFormService;
    const product = getProduct();

    trackPublishWithVisibleViolationsConfirmClose(product, 'click_fix', analyticsOfferStatus);

    form.remoteValidator.scrollToFirstError(form);

    $uibModalInstance.dismiss();
  };

  $scope.forcePublish = () => {
    const product = getProduct();

    trackPublishWithVisibleViolationsConfirmClose(product, 'click_to_publish', analyticsOfferStatus);

    $rootScope.$broadcast('publish.skipPremoderationCheck');

    $uibModalInstance.close();
  };
}
